export const golfHelpers = {
  ammendLineupGroups: (lineup, groupCount) => ammendLineupGroups(lineup, groupCount)
}

const ammendLineupGroups = (lineup, groupCount) => {
  _.forEach(lineup, (lineupItem, idx) => {
    lineupItem.position = idx;
    if (groupCount) {
      lineupItem.groupNumber = Math.floor(idx / groupCount);
    }
  });
}